<template>
    <form :data-vv-scope="form.dataVvScope" :method="form.method">

        <b-alert variant="none" show class="d-flex align-items-center justify-content-between shadow-sm">
            <div class="d-flex align-items-center">
                <i :class="newSection.is_protected ? 'fa fa-lock' : 'fa fa-unlock'" :style="{ color: newSection.is_protected ? 'red' : '#1A94C0', fontSize: '30px' }"></i>
                <div class="ml-3">
                    <strong>{{ newSection.is_protected ? 'Sección protegida' : 'Sección desprotegida' }}</strong>
                    <p class="m-0">{{ newSection.is_protected ?
                        'Esto significa que no podrás realizar acciones sobre las columnas de esta sección' :
                        'Esto significa que podrás realizar acciones sobre las columnas de esta sección'
                    }}</p>
                </div>
            </div>
            <b-form-checkbox v-if="canViewIsProtected" v-model="newSection.is_protected" name="check-button" button :button-variant="newSection.is_protected ? 'outline-danger' : 'outline-info'">
                <i :class="newSection.is_protected ? 'fa fa-lock' : 'fa fa-unlock'"></i>
                {{ newSection.is_protected ? 'Desbloquear' : 'Bloquear' }}
            </b-form-checkbox>
        </b-alert>

        <div class="form-row">

            <!-- Nombre (Identificador) -->
            <div class="form-group col-md-6">
                <label for="name">Nombre</label>
                <input data-vv-as=" " v-validate="'required|max:255'" type="text" id="name" name="name"
                    v-model="newSection.name" class="form-control" placeholder="Nombre"
                    :class="{ 'is-invalid': errors.items[0] }" />
                <small class="text-muted text-sm">Nombre (Identificador)</small>

                <span class="text-danger span-error small" v-if="errors.items[0]">
                    {{ errors.items[0].msg }}
                </span>
            </div>

            <!-- Color para la columna/file en el excel -->
            <div class="form-group col-md-4">
                <label for="color">Color</label>
                <input type="color" v-model="newSection.color" class="form-control form-control-color" />
                <small class="text-muted text-xs">Color para la columna/file en el excel</small>
            </div>

            <div class="form-group col-md-2">
                <label for="is_highlight">Resaltar componentes</label>
                <div class="highlight-toggle">
                    <b-form-checkbox
                        id="is_highlight"
                        v-model="newSection.is_highlight"
                        switch
                    >
                        {{ newSection.is_highlight ? 'Activo' : 'Inactivo' }}
                    </b-form-checkbox>
                    <b-badge :variant="newSection.is_highlight ? 'success' : 'secondary'" class="ml-2">
                        {{ newSection.is_highlight ? 'Encendido' : 'Apagado' }}
                    </b-badge>
                </div>
                <small class="text-muted text-xs">Resalta la primera columna de los componentes de esta sección en inventario.</small>
            </div>
        </div>

        <!-- Titulo para la columna/file en el excel -->
        <div class="form-group">
            <label for="head">Título</label>
            <textarea class="form-control" v-model="newSection.head" placeholder="Título..."></textarea>
            <small class="text-muted text-xs">Titulo para la columna/file en el excel</small>
        </div>

        <!-- Cas dangers -->
        <div class="form-group">
            <label for="dangers_id">Seleccionar peligros CAS</label>
            <el-select name="dangers_id" v-model="newSection.dangers_id" multiple placeholder="Seleccionar peligros">
                <el-option v-for="danger in dangers" :key="danger.id" :label="danger.lista" :value="danger.id">
                    <div class="d-flex align-items-center justify-content-between">
                        <span>{{ danger.lista }}</span>
                        <b-badge variant="info" size="md">{{ getQuantityFieldsByDanger(danger) }} Columnas</b-badge>
                    </div>
                </el-option>
            </el-select>
            <small class="text-muted text-xs">Seleccionar peligros CAS, te permite tener disponibles para la sección todas los campos de cada Peligro.</small>
        </div>

        <!-- Reglas por país -->
        <div class="mt-4 rules-card">
            <div class="rules-header">
                <div>
                    <div class="rules-title">Reglas por país</div>
                    <div class="rules-subtitle">Define exclusiones o resaltados por país y orden de aplicación.</div>
                </div>
                <div class="rules-actions">
                    <b-button size="sm" class="btn-add-rule" @click="addSectionRule">
                        <i class="fa fa-plus" /> Agregar regla
                    </b-button>
                </div>
            </div>

            <div class="rules-toolbar">
                <div class="rules-filter">
                    <label for="country_filter_id" class="rules-label">País</label>
                    <el-select name="country_filter_id" v-model="rulesCountryFilterId" filterable clearable
                        no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
                        class="rules-select">
                        <el-option v-for="country in countriesList" :key="country.id" :label="country.name"
                            :value="country.id" />
                    </el-select>
                    <small class="text-muted text-xs">Filtro opcional por país. Si no seleccionas, aplica a todos.</small>
                </div>
                <div class="rules-meta">
                    <span class="rules-count">{{ filteredSectionRules.length }}</span>
                    <span class="rules-count-label">reglas</span>
                </div>
            </div>

            <div class="table-responsive rules-table">
                <table class="table table-sm mb-0">
                    <thead>
                        <tr>
                            <th class="col-order">Orden</th>
                            <th class="col-cas">CAS</th>
                            <th class="col-rule">Regla</th>
                            <th>Componente</th>
                            <th class="col-color">Color</th>
                            <th>Campo peligro</th>
                            <th>Valor</th>
                            <th class="col-actions"></th>
                        </tr>
                    </thead>
                    <draggable v-model="filteredSectionRules" tag="tbody" handle=".drag-handle" ghost-class="ghost" @end="onRulesDragEnd">
                        <tr v-for="(rule, index) in filteredSectionRules" :key="rule.id || rule.__temp_id || index" class="rules-row">
                            <td class="align-middle" data-label="Orden">
                                <span class="drag-handle text-muted mr-2" title="Arrastrar para ordenar">
                                    <i class="fa fa-bars"></i>
                                </span>
                                <span class="order-chip">{{ rule.application_order }}</span>
                            </td>
                            <td class="align-middle" data-label="CAS">
                                <b-form-checkbox v-model="rule.is_cas" switch @change="syncRuleType(rule)">
                                    {{ rule.is_cas ? 'Sí' : 'No' }}
                                </b-form-checkbox>
                            </td>
                            <td class="align-middle" data-label="Regla">
                                <span class="rule-pill" :class="rule.is_cas ? 'rule-pill--exclude' : 'rule-pill--highlight'">
                                    {{ rule.is_cas ? 'Excluir' : 'Resaltar' }}
                                </span>
                            </td>
                            <td data-label="Componente">
                                <el-select v-if="rule.is_cas" v-model="rule.slq_product_component_id" filterable remote clearable
                                    placeholder="Componente (CAS)" no-data-text="No hay datos que coincidan"
                                    no-match-text="No hay datos que coincidan" :remote-method="(q) => searchComponentRemote(q)"
                                    class="rules-select">
                                    <el-option v-for="component in componentsWithCasName" :key="component.id"
                                        :label="`${component.cas_number} - ${component.name}`" :value="component.id" />
                                </el-select>
                                <span v-else class="text-muted small">N/A</span>
                            </td>
                            <td class="align-middle" data-label="Color">
                                <div class="color-cell" v-if="!rule.is_cas">
                                    <input type="color" v-model="rule.color_hex" class="form-control form-control-color form-control-sm" />
                                    <span class="color-hex">{{ rule.color_hex }}</span>
                                </div>
                                <span v-else class="text-muted small">N/A</span>
                            </td>
                            <td data-label="Campo peligro">
                                <el-select v-if="!rule.is_cas" v-model="rule.slq_prod_danger_field_id" filterable clearable
                                    placeholder="Campo de peligro" no-data-text="No hay datos que coincidan"
                                    no-match-text="No hay datos que coincidan" class="rules-select"
                                    @change="onDangerFieldChange(rule)">
                                    <el-option v-for="field in availableDangerFields" :key="field.id" :label="field.label"
                                        :value="field.id" />
                                </el-select>
                                <span v-else class="text-muted small">N/A</span>
                            </td>
                            <td data-label="Valor">
                                <el-select v-if="!rule.is_cas" v-model="rule.sys_list_id" filterable clearable
                                    placeholder="Valor" no-data-text="No hay datos que coincidan"
                                    no-match-text="No hay datos que coincidan" class="rules-select"
                                    :disabled="getRuleValueOptions(rule).length === 0">
                                    <el-option v-for="item in getRuleValueOptions(rule)" :key="item.id"
                                        :label="item.lista" :value="item.id" />
                                </el-select>
                                <span v-else class="text-muted small">N/A</span>
                            </td>
                            <td class="align-middle text-center" data-label="Acciones">
                                <b-button size="sm" variant="danger" class="btn-icon" @click="removeSectionRule(index)">
                                    <i class="fa fa-trash" />
                                </b-button>
                            </td>
                        </tr>
                        <tr v-if="filteredSectionRules.length === 0">
                            <td colspan="8" class="text-center text-muted py-4">No hay reglas registradas</td>
                        </tr>
                    </draggable>
                </table>
            </div>
        </div>

        <button v-if="!newSection.is_protected && !canViewIsProtected || canViewIsProtected" type="button" class="btn btn-primary btn-sm mt-4" @click="$emit('on-btn-ok')">
            <i :class="`fa fa-${form.btnIcon}`" /> {{ form.btnTitle }}
        </button>
    </form>
</template>

<script>

// Generales
import { mapActions, mapMutations, mapState } from "vuex";
import draggable from "vuedraggable";

// Plugins
import { validarPermisoComponente } from "../../../../plugins/acl";

export default {

    name: 'InventoryComponentForm',

    components: {
        draggable,
    },

    data() {
        return {
            rulesCountryFilterId: null
        };
    },

    props: {
        action: {
            type: String,
            default: 'CREATE'
        },
        dangers: {
            type: Array,
            default: () => []
        }
    },

    mounted() {
        this.resetForm();
        this.setDataForm()
    },

    computed: {

        ...mapState('sections', ['newSection', 'form']),
        ...mapState('countries', { countriesList: 'countries' }),
        ...mapState('nuevocas', ['componentes']),

        canViewIsProtected() {
            return validarPermisoComponente('cambiar-estado-proteccion-secciones-inventario');
        },

        availableDangerFields() {
            const dangerIds = Array.isArray(this.newSection.dangers_id) ? this.newSection.dangers_id : [];
            if (dangerIds.length === 0) return [];
            const sourceDangers = Array.isArray(this.dangers) ? this.dangers : [];

            return sourceDangers
                .filter(danger => dangerIds.includes(danger.id))
                .flatMap(danger => {
                    const fields = Array.isArray(danger.danger_fields) ? danger.danger_fields : [];
                    return fields.map(field => ({
                        id: field.id,
                        label: `${danger.lista} - ${field.label}`,
                        sys_control_list_select_id: field.sys_control_list_select_id || null,
                        danger_field_lists: Array.isArray(field.danger_field_lists) ? field.danger_field_lists : []
                    }));
                })
                .filter(field => !!field.sys_control_list_select_id);
        },

        componentsWithCasName() {
            const fromSearch = Array.isArray(this.componentes) ? this.componentes : [];
            const fromRules = (Array.isArray(this.newSection.section_rules) ? this.newSection.section_rules : [])
                .map(r => r && r.product_component)
                .filter(Boolean);

            const byId = new Map();
            [...fromRules, ...fromSearch].forEach(item => {
                if (!item || !item.id) return;
                byId.set(item.id, item);
            });

            return Array.from(byId.values()).filter(item => item && item.cas_number && item.name);
        },

        filteredSectionRules: {
            get() {
                const rules = Array.isArray(this.newSection.section_rules) ? this.newSection.section_rules : [];
                if (!this.rulesCountryFilterId) {
                    return rules.filter(rule => !rule.slq_country_id);
                }
                return rules.filter(rule => rule.slq_country_id === this.rulesCountryFilterId);
            },
            set(nextList) {
                if (!Array.isArray(this.newSection.section_rules)) {
                    this.newSection.section_rules = [];
                }
                if (!this.rulesCountryFilterId) {
                    const otherRules = this.newSection.section_rules.filter(
                        rule => rule.slq_country_id
                    );
                    this.newSection.section_rules = [...otherRules, ...nextList];
                    this.normalizeRuleOrder();
                    return;
                }
                const otherRules = this.newSection.section_rules.filter(
                    rule => rule.slq_country_id !== this.rulesCountryFilterId
                );
                this.newSection.section_rules = [...otherRules, ...nextList];
                this.normalizeRuleOrder();
            }
        }

    },

    methods: {

        ...mapMutations('sections', ['resetForm', 'setForm', 'setNewSection']),
        ...mapActions('sections', ['getSectionById', 'inactivateSectionRule']),
        ...mapActions('nuevocas', ['ListarComponentes']),

        getQuantityFieldsByDanger(danger) {
            return danger.danger_fields && typeof danger.danger_fields === 'object' ?
                danger.danger_fields.length : 0
        },

        searchComponentRemote(query) {
            if (!query || query.length < 3) return;
            this.ListarComponentes(query);
        },

        createEmptyRule() {
            return {
                rule_type: "highlight",
                is_cas: false,
                color_hex: "#FFFFFF",
                application_order: 1,
                is_active: true,
                inventory_section_id: this.newSection.id || null,
                slq_country_id: this.rulesCountryFilterId || null,
                slq_product_component_id: null,
                slq_prod_danger_field_id: null,
                sys_list_id: null,
                __temp_id: `rule_${Date.now()}_${Math.random().toString(16).slice(2)}`
            };
        },

        addSectionRule() {
            if (!Array.isArray(this.newSection.section_rules)) {
                this.newSection.section_rules = [];
            }
            this.newSection.section_rules.push(this.createEmptyRule());
            this.normalizeRuleOrder();
        },

        removeSectionRule(index) {
            if (!Array.isArray(this.newSection.section_rules)) return;
            const list = this.filteredSectionRules;
            const ruleToRemove = list[index];
            if (ruleToRemove && ruleToRemove.id) {
                this.$alertConfirmation({
                    icon: 'question',
                    title: "¿Está seguro de eliminar esta regla?",
                    text: "Esta acción inactivará la regla.",
                    showConfirmButton: true,
                    showCancelButton: true,
                    titleBtnConfirm: "Eliminar",
                    titleBtnCancel: "Cancelar",
                    onConfirm: async () => {
                        this.inactivateSectionRule({
                            id: ruleToRemove.id,
                            callback: async (ok) => {
                                if (!ok) return;
                                await this.refreshSectionRulesByCountry();
                            }
                        });
                    }
                });
                return;
            }
            this.newSection.section_rules = this.newSection.section_rules.filter(r => r !== ruleToRemove);
            this.normalizeRuleOrder();
        },

        validateRules() {
            const rules = Array.isArray(this.newSection.section_rules) ? this.newSection.section_rules : [];
            const seenByCountryComponent = {};
            const seenByCountryField = {};
            for (const rule of rules) {
                const countryKey = rule.slq_country_id ? String(rule.slq_country_id) : 'null';
                if (rule.is_cas) {
                    if (!rule.slq_product_component_id) {
                        this.$alertError("El componente es obligatorio cuando es CAS.");
                        return false;
                    }
                    const componentId = String(rule.slq_product_component_id);
                    if (!seenByCountryComponent[countryKey]) {
                        seenByCountryComponent[countryKey] = new Set();
                    }
                    if (seenByCountryComponent[countryKey].has(componentId)) {
                        this.$alertError("No se puede repetir el componente en el mismo país.");
                        return false;
                    }
                    seenByCountryComponent[countryKey].add(componentId);
                } else {
                    if (!rule.color_hex) {
                        this.$alertError("El color es obligatorio cuando no es CAS.");
                        return false;
                    }
                    if (!rule.slq_prod_danger_field_id) {
                        this.$alertError("El campo de peligro es obligatorio cuando no es CAS.");
                        return false;
                    }
                    const fieldId = String(rule.slq_prod_danger_field_id);
                    if (!seenByCountryField[countryKey]) {
                        seenByCountryField[countryKey] = new Set();
                    }
                    if (seenByCountryField[countryKey].has(fieldId)) {
                        this.$alertError("No se puede repetir el campo de peligro en el mismo país.");
                        return false;
                    }
                    const valueOptions = this.getRuleValueOptions(rule);
                    if (valueOptions.length > 0 && !rule.sys_list_id) {
                        this.$alertError("El valor es obligatorio cuando el campo de peligro tiene lista de control.");
                        return false;
                    }
                    seenByCountryField[countryKey].add(fieldId);
                }
            }
            return true;
        },

        async refreshSectionRulesByCountry() {
            if (!this.newSection.id) return;
            const response = await this.getSectionById({
                id: this.newSection.id,
                slq_country_id: this.rulesCountryFilterId || null
            });
            this.setNewSection({
                ...this.newSection,
                section_rules: Array.isArray(response.section_rules)
                    ? response.section_rules.map(rule => ({
                        ...rule,
                        is_cas: !!rule.is_cas,
                        sys_list_id: rule.sys_list_id || null
                    }))
                    : []
            });
        },

        syncRuleType(rule) {
            rule.rule_type = rule.is_cas ? "exclude" : "highlight";
            if (rule.is_cas) {
                rule.color_hex = "#FFFFFF";
                rule.slq_prod_danger_field_id = null;
                rule.sys_list_id = null;
            } else {
                rule.slq_product_component_id = null;
            }
        },

        getDangerFieldById(fieldId) {
            if (!fieldId) return null;
            return this.availableDangerFields.find(field => field.id === fieldId) || null;
        },

        getRuleValueOptions(rule) {
            if (!rule || rule.is_cas || !rule.slq_prod_danger_field_id) return [];
            const selectedField = this.getDangerFieldById(rule.slq_prod_danger_field_id);
            return selectedField && Array.isArray(selectedField.danger_field_lists)
                ? selectedField.danger_field_lists
                : [];
        },

        onDangerFieldChange(rule) {
            if (!rule) return;
            const options = this.getRuleValueOptions(rule);
            if (options.length === 0) {
                rule.sys_list_id = null;
                return;
            }
            const currentValueExists = options.some(item => item.id === rule.sys_list_id);
            if (!currentValueExists) {
                rule.sys_list_id = null;
            }
        },

        normalizeRuleOrder() {
            if (!Array.isArray(this.newSection.section_rules)) return;
            const orderByCountry = new Map();
            this.newSection.section_rules = this.newSection.section_rules.map((rule) => {
                const countryKey = rule.slq_country_id || '__NO_COUNTRY__';
                const nextOrder = (orderByCountry.get(countryKey) || 0) + 1;
                orderByCountry.set(countryKey, nextOrder);

                return {
                    ...rule,
                    is_cas: !!rule.is_cas,
                    application_order: nextOrder,
                    rule_type: rule.is_cas ? "exclude" : "highlight",
                    sys_list_id: rule.is_cas ? null : (rule.sys_list_id || null)
                };
            });
        },

        onRulesDragEnd() {
            this.normalizeRuleOrder();
        },

        setDataForm() {
            const action = this.action === 'CREATE' ? true : false
            this.setForm({
                action: this.action,
                dataVvScope: action ? 'form-crate-sections' : 'form-update-sections',
                method: action ? 'POST' : 'PUT',
                btnTitle: action ? 'Crear sección' : 'Guardar cambios',
                btnIcon: action ? 'plus-circle' : 'pencil'
            });
        }
    },

    watch: {
        'newSection.id'(nextVal) {
            if (!Array.isArray(this.newSection.section_rules)) return;
            this.newSection.section_rules = this.newSection.section_rules.map(rule => ({
                ...rule,
                inventory_section_id: nextVal || null,
                is_cas: !!rule.is_cas,
                sys_list_id: rule.is_cas ? null : (rule.sys_list_id || null)
            }));
        },
        rulesCountryFilterId(nextVal) {
            if (this.newSection.id) {
                this.refreshSectionRulesByCountry();
                return;
            }
            if (!nextVal) return;
            if (!Array.isArray(this.newSection.section_rules)) return;
            this.newSection.section_rules = this.newSection.section_rules.map(rule => ({
                ...rule,
                slq_country_id: rule.slq_country_id || nextVal
            }));
        },
        'newSection.section_rules': {
            deep: true,
            handler() {}
        }
    },

}

</script>

<style scoped>
.rules-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 18px 18px 12px 18px;
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.06);
}

.highlight-toggle {
    display: flex;
    align-items: center;
    min-height: 38px;
}

.rules-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
}

.rules-title {
    font-weight: 700;
    font-size: 16px;
    color: #0f172a;
}

.rules-subtitle {
    font-size: 12px;
    color: #64748b;
}

.rules-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-add-rule {
    background: #0f766e;
    border-color: #0f766e;
    color: #fff;
}

.btn-add-rule:hover {
    background: #0d6b63;
    border-color: #0d6b63;
}

.rules-toolbar {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    padding: 10px 12px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    margin-bottom: 12px;
}

.rules-filter {
    min-width: 280px;
}

.rules-label {
    font-size: 12px;
    color: #475569;
    margin-bottom: 6px;
}

.rules-select {
    width: 100%;
}

.rules-meta {
    display: flex;
    align-items: baseline;
    gap: 6px;
    color: #334155;
}

.rules-count {
    font-weight: 700;
    font-size: 20px;
}

.rules-count-label {
    font-size: 12px;
    color: #64748b;
}

.rules-table {
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
}

.rules-table table {
    border-collapse: separate;
    border-spacing: 0;
}

.rules-table thead th {
    background: #eef2f7;
    color: #475569;
    font-size: 12px;
    font-weight: 700;
    border-bottom: 1px solid #e2e8f0;
    padding: 10px 12px;
}

.rules-table tbody td {
    border-top: 1px solid #eef2f7;
    padding: 10px 12px;
    vertical-align: middle;
}

.rules-row:hover {
    background: #f8fafc;
}

.col-order { width: 90px; }
.col-cas { width: 120px; }
.col-rule { width: 130px; }
.col-color { width: 140px; }
.col-actions { width: 64px; }

.drag-handle {
    cursor: grab;
}

.order-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 24px;
    border-radius: 999px;
    background: #e2e8f0;
    color: #0f172a;
    font-weight: 700;
    font-size: 12px;
}

.rule-pill {
    display: inline-flex;
    align-items: center;
    padding: 2px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
}

.rule-pill--exclude {
    background: #fee2e2;
    color: #b91c1c;
}

.rule-pill--highlight {
    background: #cffafe;
    color: #0f766e;
}

.btn-icon {
    padding: 4px 8px;
}

.color-cell {
    display: flex;
    align-items: center;
    gap: 8px;
}

.color-hex {
    font-size: 11px;
    color: #64748b;
}

@media (max-width: 768px) {
    .rules-header {
        flex-direction: column;
        align-items: flex-start;
    }

    .rules-actions {
        width: 100%;
        justify-content: flex-start;
    }

    .btn-add-rule {
        width: 100%;
    }

    .rules-toolbar {
        flex-direction: column;
        align-items: stretch;
    }

    .rules-filter {
        min-width: 100%;
    }

    .rules-meta {
        justify-content: flex-end;
    }

    .rules-table {
        border-radius: 8px;
    }

    .col-order { width: 72px; }
    .col-cas { width: 90px; }
    .col-rule { width: 100px; }
    .col-color { width: 110px; }
    .col-actions { width: 56px; }

    .rules-table table,
    .rules-table thead,
    .rules-table tbody,
    .rules-table th,
    .rules-table td,
    .rules-table tr {
        display: block;
        width: 100%;
    }

    .rules-table thead {
        display: none;
    }

    .rules-row {
        background: #ffffff;
        border: 1px solid #e2e8f0;
        border-radius: 10px;
        margin-bottom: 10px;
        padding: 8px 10px;
    }

    .rules-table tbody td {
        border: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        padding: 8px 0;
    }

    .rules-table tbody td::before {
        content: attr(data-label);
        font-size: 11px;
        font-weight: 700;
        color: #64748b;
        text-transform: uppercase;
        letter-spacing: 0.04em;
    }

    .rules-table tbody td[data-label="Acciones"] {
        justify-content: flex-end;
    }
}

@media (max-width: 480px) {
    .rules-card {
        padding: 14px 14px 10px 14px;
    }

    .rules-title {
        font-size: 15px;
    }

    .rules-subtitle {
        font-size: 11px;
    }

    .rules-table thead th,
    .rules-table tbody td {
        padding: 8px 10px;
    }

    .order-chip {
        min-width: 22px;
        height: 22px;
        font-size: 11px;
    }

    .rule-pill {
        font-size: 11px;
        padding: 2px 8px;
    }
}
</style>
